import type { FaireProductEntity } from "../../entity_types/product";

export const p_2n4bk4r43m: FaireProductEntity = {
  token: "p_2n4bk4r43m",
  type: "product",
  name: "3P4 x Peanuts® - Snoopy Dracula Air Freshener",
  brandToken: "b_ajtucnxx1w",
  brandName: "Three Potato Four",
  imageUrl:
    "https://cdn.faire.com/fastly/d49b41606a7291a8c90bf097208bb40a76dcd296deab0c76ccbf95ea05cdaca9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/41fef56b443af99f6a68d4fafe54820c3c560a976bc44bdc008cf9f501a34353.jpeg",
    "https://cdn.faire.com/fastly/29ca0021bbb145e63e679da995afff60cae7b666959513706cac4ae5ddf5a304.webp",
  ],
  priceDollars: 4.5,
  description:
    'Limited Edition Snoopy Halloween\n\nSuper cute, vintage-inspired Snoopy air freshener. Perfect for car, bathroom, office, laundry room, or any other spot that needs that sweet scent of cinnamon with classic Snoopy styling.\n\n• Officially Licensed Product of Peanuts©\n• Hanging Air Freshener\n• Approximately 3" with Hanging Elastic Band\n• Produced and packaged in the USA\n• Cinnamon Scent',
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:29.872Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
